/* eslint-disable */

/***************
 * this is modified version of this plugin:
 * https://github.com/websanova/wScratchPad
 *
 * This is only for a POC.
 * When moving to production this entire plugin should be re-written.
 * -roger
 */

export default function initiateScratchLibrary($) {
  'use strict';

  function ScratchPad(el, options) {
    this.$el = $(el);
    this.options = options;
    this.generateScratchPad();
  }

  ScratchPad.prototype = {
    setupBackgroundImage: function(maxHeight, maxWidth) {
      var bgImage = this.options.bg;
      var pos = positionForImage(this.options.bg, maxHeight, maxWidth);

      return $(bgImage)
        .css({
          width: pos.width,
          height: pos.height,
          position: 'absolute',
          display: 'block',
          left: pos.left + 'px',
          top: pos.top + 'px'
        })
        .attr('draggable', 'false')
        .addClass('mi-image');
    },

    setupContainerElement: function(height, width) {
      // Make sure it's at least relative.
      var $el = this.$el;

      if ($el.css('position') === 'static') {
        $el.css('position', 'relative');
      }

      $el.css({
        cursor: this.options.cursor,
        height: height + 'px',
        width: width + 'px'
      });
    },

    maxWidthDimension: function() {
      var fg = this.options.fg;
      var bg = this.options.bg;
      return Math.max(fg.width, bg.width);
    },

    maxHeightDimension: function() {
      var fg = this.options.fg;
      var bg = this.options.bg;
      return Math.max(fg.height, bg.height);
    },

    createCanvasElement: function() {
      return $('<canvas>');
    },

    setupScratchpad: function($scratchpad, ctx, maxHeight, maxWidth) {
      var image = this.options.fg;
      var pos = positionForImage(image, maxHeight, maxWidth);
      var devicePixelRatio = window.devicePixelRatio || 1;

      $scratchpad.css({
        position: 'absolute',
        width: pos.width,
        height: pos.height,
        left: pos.left + 'px',
        top: pos.top + 'px'
      });

      var canvas = $scratchpad.get(0);
      canvas.setAttribute('width', pos.width * devicePixelRatio);
      canvas.setAttribute('height', pos.height * devicePixelRatio);
      ctx.scale(devicePixelRatio, devicePixelRatio);
      ctx.drawImage(image, 0, 0, pos.width, pos.height);
    },

    generateScratchPad: function() {
      var maxHeight = this.maxHeightDimension();
      var maxWidth = this.maxWidthDimension();

      this.setupContainerElement(maxHeight, maxWidth);

      var $bgImage = this.setupBackgroundImage(maxHeight, maxWidth);
      var $scratchpad = this.createCanvasElement();
      var ctx = (this.ctx = $scratchpad.get(0).getContext('2d'));

      this.setupScratchpad($scratchpad, ctx, maxHeight, maxWidth);

      $scratchpad.bindMobileEvents();

      // Setup event handlers.
      this.$el.mousedown($.proxy(this.handleMouseDown, this));

      this.$el.append($bgImage).append($scratchpad);
      this.canvasOffset = $scratchpad.offset();
    },

    positionForEvent: function(e) {
      return {
        x: e.pageX - this.canvasOffset.left,
        y: e.pageY - this.canvasOffset.top
      };
    },

    addScratchingHandlers: function(e) {
      $('body')
        .on('mousemove.scratchpad', $.proxy(this.handleMouseMove, this))
        .on('mouseup.scratchpad', $.proxy(this.handleMouseUp, this));
    },

    removeScratchingHandlers: function(e) {
      $('body')
        .off('mousemove.scratchpad')
        .off('mouseup.scratchpad');
    },

    handleMouseDown: function(e) {
      this.addScratchingHandlers();
      this.scratchDown(this.ctx, this.positionForEvent(e));

      $('body').css('user-select', 'none');
    },

    handleMouseMove: function(e) {
      this.scratchMove(this.ctx, this.positionForEvent(e));
    },

    handleMouseUp: function(e) {
      this.scratchUp(this.ctx, this.positionForEvent(e));
      this.removeScratchingHandlers();

      $('body').css('user-select', '');
    },

    scratchDown: function(ctx, position) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      ctx.strokeStyle = this.options.color;
      ctx.lineWidth = this.options.size;

      //draw single dot in case of a click without a move
      ctx.beginPath();
      ctx.arc(
        position.x,
        position.y,
        this.options.size / 2,
        0,
        Math.PI * 2,
        true
      );
      ctx.closePath();
      ctx.fill();

      //start the path for a drag
      ctx.beginPath();
      ctx.moveTo(position.x, position.y);
    },

    scratchMove: function(ctx, position) {
      ctx.lineTo(position.x, position.y);
      ctx.stroke();
    },

    scratchUp: function(ctx) {
      ctx.closePath();
    }
  };

  function positionForImage(image, maxHeight, maxWidth) {
    var width = image.width;
    var height = image.height;
    var left = (maxWidth - width) / 2;
    var top = (maxHeight - height) / 2;

    return {
      width: width,
      height: height,
      left: left,
      top: top
    };
  }

  $.fn.wScratchPad = function(options, value) {
    return this.each(function(idx, elem) {
      return new ScratchPad(elem, $.extend(true, {}, options));
    });
  };

  $.fn.wScratchPad.defaults = {
    size: 5, // The size of the brush/scratch.
    bg: null,
    fg: null,
    cursor: 'pointer'
  };

  $.fn.bindMobileEvents = function() {
    $(this).on('touchstart touchmove touchend touchcancel', function(event) {
      var touches = event.changedTouches || event.originalEvent.targetTouches,
        first = touches[0],
        type = '';

      switch (event.type) {
        case 'touchstart':
          type = 'mousedown';
          break;
        case 'touchmove':
          type = 'mousemove';
          event.preventDefault();
          break;
        case 'touchend':
          type = 'mouseup';
          break;
        default:
          return;
      }

      var simulatedEvent = document.createEvent('MouseEvent');

      simulatedEvent.initMouseEvent(
        type,
        true,
        true,
        window,
        1,
        first.screenX,
        first.screenY,
        first.clientX,
        first.clientY,
        false,
        false,
        false,
        false,
        0 /*left*/,
        null
      );

      first.target.dispatchEvent(simulatedEvent);
    });
  };
}
